import React from 'react';
import { Route } from 'react-router-dom';

import * as routeLookup from 'App/common/routeLookup';
import CloneAssessmentPage from 'App/components/AssessmentManager/CloneAssessmentPage';
import AssessmentManagerHome from './AssessmentManagerHome/AssessmentManagerHome';
import AssessmentManagerQuestions from './AssessmentManagerQuestions/AssessmentManagerQuestions';
import AssessmentManagerCreateSettings from './AssessmentManagerSettings/AssessmentManagerCreateSettings';
import AssessmentManagerEditSettings from './AssessmentManagerSettings/AssessmentManagerEditSettings';

const AssessmentManagerRouter = (
    <>
        <Route path={routeLookup.assessmentManagerChildQuestionsRoute} element={<AssessmentManagerQuestions />} />
        <Route path={routeLookup.assessmentManagerQuestionsRoute} element={<AssessmentManagerQuestions />} />

        <Route path={routeLookup.assessmentManagerCreateRoute} element={<AssessmentManagerCreateSettings />} />

        <Route path={routeLookup.assessmentManagerEditRoute} element={<AssessmentManagerEditSettings />} />

        <Route path={routeLookup.assessmentManagerCloneRoute} element={<CloneAssessmentPage />} />

        <Route path={routeLookup.assessmentManagerHomeRoute} element={<AssessmentManagerHome />} />
    </>
);

export default AssessmentManagerRouter;
